import { collection, doc, setDoc, getDocs } from 'firebase/firestore';
import { db } from '../config/firebase';
import { allServicesData } from '../data/servicesData';

// Quick data upload function that can be called from console
export const quickUploadData = async () => {
  console.log('🚀 Starting quick data upload...');
  
  try {
    // 1. Upload Categories
    console.log('📁 Uploading categories...');
    const categories = [
      {
        id: 'beauty',
        name: 'Beauty',
        description: 'Professional beauty and grooming services at your doorstep',
        icon: '💄',
        backgroundColor: '#FEE2E2',
        color: '#EF4444',
        image: 'https://images.unsplash.com/photo-1570172619644-dfd03ed5d881?w=800&h=600&fit=crop',
        popular: true,
        showOnHomepage: true,
        order: 1,
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      },
      {
        id: 'wellness',
        name: 'Wellness',
        description: 'Relaxation and wellness therapies for your well-being',
        icon: '🧘',
        backgroundColor: '#DBEAFE',
        color: '#3B82F6',
        image: 'https://images.unsplash.com/photo-1544161515-4ab6ce6db874?w=800&h=600&fit=crop',
        popular: true,
        showOnHomepage: true,
        order: 2,
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      },
      {
        id: 'repair',
        name: 'Repair',
        description: 'Expert repair and maintenance services for your home',
        icon: '🔧',
        backgroundColor: '#FEF3C7',
        color: '#F59E0B',
        image: 'https://images.unsplash.com/photo-1621905251918-48416bd8575a?w=800&h=600&fit=crop',
        popular: true,
        showOnHomepage: true,
        order: 3,
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      },
      {
        id: 'home-care',
        name: 'Home Care',
        description: 'Comprehensive home cleaning and care solutions',
        icon: '🏠',
        backgroundColor: '#D1FAE5',
        color: '#10B981',
        image: 'https://images.unsplash.com/photo-1581578731548-c64695cc6952?w=800&h=600&fit=crop',
        popular: true,
        showOnHomepage: true,
        order: 4,
        isActive: true,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      }
    ];

    for (const category of categories) {
      await setDoc(doc(db, 'categories', category.id), category);
      console.log(`✓ Category uploaded: ${category.name}`);
    }
    
    // 2. Upload Services
    console.log('\n📦 Uploading services...');
    const categoryMap: Record<string, string> = {
      'Beauty': 'beauty',
      'Wellness': 'wellness',
      'Repair': 'repair',
      'Home Care': 'home-care'
    };
    
    let uploadedCount = 0;
    for (const service of allServicesData) {
      const categoryId = categoryMap[service.category] || service.category.toLowerCase().replace(/\s+/g, '-');
      
      const serviceData = {
        ...service,
        categoryId,
        isActive: true,
        showOnHomePage: service.popular || false,
        showInPopularSection: service.popular || false,
        showInFeaturedSection: (service as any).featured || false,
        createdAt: new Date().toISOString(),
        updatedAt: new Date().toISOString()
      };
      
      const serviceRef = doc(collection(db, 'services'));
      await setDoc(serviceRef, serviceData);
      uploadedCount++;
      
      if (uploadedCount % 10 === 0) {
        console.log(`  Uploaded ${uploadedCount}/${allServicesData.length} services...`);
      }
    }
    
    console.log(`✓ All ${uploadedCount} services uploaded!`);
    
    // 3. Verify Upload
    console.log('\n✅ Verifying upload...');
    const categoriesSnapshot = await getDocs(collection(db, 'categories'));
    const servicesSnapshot = await getDocs(collection(db, 'services'));
    
    console.log(`\n📊 Upload Summary:`);
    console.log(`  Categories: ${categoriesSnapshot.size}`);
    console.log(`  Services: ${servicesSnapshot.size}`);
    console.log('\n🎉 Data upload complete! Refresh the page to see services.');
    
    return {
      success: true,
      categories: categoriesSnapshot.size,
      services: servicesSnapshot.size
    };
    
  } catch (error) {
    console.error('❌ Upload failed:', error);
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown error'
    };
  }
};

// Make it available in window
if (typeof window !== 'undefined') {
  (window as any).quickUploadData = quickUploadData;
}
